import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { ReconciliationSpecificationRowActionButtonProps } from "models/propTypes/accountingPropTypes";
//#endregion
//#region components
import useAuditSheetPreview from "./hooks/useAuditSheetPreview";
import { useAuditService } from "serviceHooks";
import { TableActionButtonss } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const ReconciliationSpecificationRowActionButtons: React.FC<ReconciliationSpecificationRowActionButtonProps> = (
  props
) => {
  const auditService = useAuditService();

  const { auditSheetId, auditSheetTitle, navigationItems } = props;

  const { showAuditSheetPreviewDialog } = useAuditSheetPreview();

  const onDownloadReportRow = async () => {
    return auditService.getAuditSheetPdf(auditSheetId);
  };

  const onOpenReportRow = async () => {
    showAuditSheetPreviewDialog(auditSheetId, auditSheetTitle, navigationItems);
  };

  return (
    <TableActionButtonss
      actions={[
        {
          onClickHandler: onDownloadReportRow,
          icon: IconDefinitionConstants.WDownloadSmall,
          toolTipText: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.DownloadSpecification),
        },
        {
          onClickHandler: onOpenReportRow,
          icon: IconDefinitionConstants.WListSmall,
          toolTipText: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.OpenAccountSpecification),
        },
      ]}
      size="small"
    />
  );
};

export default ReconciliationSpecificationRowActionButtons;
